import React from "react";
import Slide1 from "../../assets/img/carousal/slide1.jpg";
import Typical from "react-typical";
import { Container, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  Home: {
    margin: 0,
    padding: 0,
    fontFamily: "Arial, sans-serif"
  },
  Container: {
    margin: 0,
    padding: 0,
    maxHeight: "75vh",
    maxWidth: "100vw",
    textAlign: "center",
    color: "white",
  },
  img: {
    padding: 0,
    margin: 0,
    height: "75vh",
    width: "100%",
    backgroundSize: "cover",
    filter: "brightness(50%)",
    animation: "$fadeLeft 1s",
  },
  LandingText: {
    height: "20vh",
    width: "45vw",
    position: "absolute",
    top: "25%",
    left: "25%",
  },
  "@keyframes fadeLeft": {
    "from": {
        opacity: "0",
        transform: "translate3d(-100%,0,0)",
    },
    "to": {
        opacity: "1",
        transform: "translate(-100%,0,0)",
    },
},
}));

const MyCarousal = () => {
  const classes = useStyles();
  return (
    <div id="home"  className = {classes.Home}>
      <Container className = {classes.Container}>
          <img src = {Slide1} className = {classes.img} alt = "Background"/>  
        <div className = {classes.LandingText}>
          <h2>Need to hire a cloud computing consultant? We can help!</h2>
            <Typical
              loop = {Infinity}
              wrapper = "h4"
              steps = {[
                'App Modernization',
                1000,
                'Cloud and DataCenter Modernization',
                1000,
                'Data and AI',
                1000,
                'Cybersecurity',
                1000,
                'Smart IVR Technology',
                1000

              ]}
            />
        </div>
      </Container>
    </div>
  );
};

export default MyCarousal;
